/**
 * A failed campaign load. A permission refusal says so and offers nothing to
 * retry; anything else offers to try again.
 */
import { TicketSalesCampaignApiError } from '../../../api/ticket-sales-campaigns';

export function TicketSalesCampaignsLoadError({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry: () => void;
}) {
  const forbidden = error instanceof TicketSalesCampaignApiError && error.status === 403;
  return (
    <div
      role="alert"
      className="nb-card nb-card-tight"
      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 16, margin: 14 }}
    >
      <span style={{ fontSize: 13, color: 'var(--nb-ink-2)' }}>
        {forbidden
          ? 'You don’t have permission to view campaigns.'
          : 'Campaigns couldn’t be loaded.'}
      </span>
      {!forbidden && (
        <button type="button" className="nb-btn" onClick={onRetry} style={{ marginLeft: 'auto' }}>
          Try again
        </button>
      )}
    </div>
  );
}
